import React, { useState } from "react";
import { useDispatch } from "react-redux";
import {
  deleteAllProductImages,
  deleteProductOneImage,
  uploadProductImages,
} from "../../redux/reducer/productReducer";
//

const GalleryImagesForm = ({ productId, images, onCancel, refreshData }) => {
  const dispatch = useDispatch();
  const [selectedImages, setSelectedImages] = useState([]);
  const [isUploading, setIsUploading] = useState(false);

  const handleDelete = (index) => {
    if (window.confirm("Are you sure you want to delete this image?")) {
      dispatch(deleteProductOneImage({ productId, index }))
        .unwrap()
        .then(() => {
          refreshData();
        });
    }
  };

  const handleDeleteAll = () => {
    if (window.confirm("Delete ALL images? This action is irreversible.")) {
      dispatch(deleteAllProductImages(productId))
        .unwrap()
        .then(() => {
          refreshData();
        });
    }
  };

  const handleImageChange = (e) => {
    const files = Array.from(e.target.files);
    setSelectedImages(files);
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    if (selectedImages.length === 0) {
      alert("Please select at least one image.");
      return;
    }

    setIsUploading(true);
    dispatch(uploadProductImages({ id: productId, images: selectedImages }))
      .unwrap()
      .then(() => {
        setSelectedImages([]);
        refreshData();
      })
      .finally(() => {
        setTimeout(() => {
          setIsUploading(false);
        }, 10000);
      });
  };

  // console.log(images)
  return (
    <div
      className="absolute z-[999999999999999999] gap-4 p-6 bg-white shadow-lg 
      top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2 rounded-md w-[90%] md:w-[800px]"
    >
      <form onSubmit={handleSubmit} className="w-full p-4 mx-auto bg-white">
        <div className="flex items-center justify-between mb-4">
          <h2 className="text-lg font-bold text-black">Gallery Images</h2>
          {images.length > 0 && (
            <button
              type="button"
              onClick={handleDeleteAll}
              className="px-3 py-1 text-sm text-white bg-red-600 rounded-md"
            >
              Delete All Images
            </button>
          )}
        </div>

        <div className="flex w-full gap-2 mb-4 ">
          {images.length === 0 ? (
            <p className="w-full my-4 text-center text-black">
              No images found
            </p>
          ) : (
            <div className="max-h-[40vh] overflow-y-scroll my-4 grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-5 gap-4">
              {images.map((imgUrl, index) => (
                <div key={index} className="relative w-full h-32">
                  <a href={imgUrl} target="_blank" rel="noopener noreferrer">
                    <img
                      src={imgUrl}
                      alt={`Gallery ${index}`}
                      className="object-cover w-full h-full rounded cursor-pointer"
                    />
                  </a>
                  <button
                    type="button"
                    onClick={() => handleDelete(index)}
                    className="absolute top-0 right-0 px-1 py-0.5 text-xs text-white bg-red-600 rounded-bl"
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="mb-4">
          <label className="block mb-1 text-sm font-medium text-gray-700">
            Upload New Images
          </label>
          <input
            type="file"
            accept="image/*"
            multiple
            onChange={handleImageChange}
            className="block w-full text-sm text-gray-500"
          />
        </div>

        <div className="flex justify-end col-span-2 mt-2 space-x-3">
          <button
            type="button"
            onClick={onCancel}
            className="px-4 py-1 text-black bg-gray-300 rounded-md"
          >
            Cancel
          </button>
          <button
            type="submit"
            disabled={isUploading}
            className={`px-4 py-1 text-white rounded-md bg-custom-yellow ${
              isUploading ? "opacity-50 cursor-not-allowed" : ""
            }`}
          >
            {isUploading ? "Uploading..." : "Upload"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default GalleryImagesForm;
